import React from 'react'
import { connect, useSelector } from 'react-redux'
import { defineMessages, FormattedMessage } from 'react-intl'
import {
  selectTotalEquity,
  selectEmergencyReservePool
} from 'src/store/selectors/home/equity'
import { Text } from 'src/Components'
import {
  Heading,
  ProConList,
  Pro,
  Info
} from 'src/Components/shared/Gem/GemDetail'
import Format from 'Components/shared/Format'

const EmergencyReserve = props => {
  const equity = useSelector(selectTotalEquity)
  const pool = useSelector(selectEmergencyReservePool)

  return (
    <div>
      <Heading>
        <FormattedMessage
          id='Homeowner.equity.emergenciesHeading'
          defaultMessage='During uncertain times, you still have some things within your control. Having access to 6-12 months of living expenses can prepare you for whatever happens next.'
        />
      </Heading>

      <ProConList>
        <Pro>
          <FormattedMessage
            id='Homeowner.equity.emergenciesOne'
            defaultMessage='With your {equity} equity, you could have about {pool} to work with, depending on market rates, your current financial situation, home occupancy status, and refi goals. (And, it’s smart to leave at least 25% of your equity in your home.)'
            values={{
              equity: (
                <Text element='span' weight='bold'>
                  <Format.Currency value={equity} abbreviate />
                </Text>
              ),
              pool: (
                <Text element='span' weight='bold'>
                  <Format.Currency value={pool} abbreviate />
                </Text>
              )
            }}
          />
        </Pro>
        <Pro>
          <FormattedMessage
            id='Homeowner.equity.emergenciesTwo'
            defaultMessage='A cash-out refi or second loan can give you easy access to cash for when you need it most'
          />
        </Pro>
        <Info>
          <FormattedMessage
            id='Homeowner.equity.emergenciesThree'
            defaultMessage='Make sure to stay disciplined and only use the money for true emergencies'
          />
        </Info>
      </ProConList>
    </div>
  )
}

const messages = defineMessages({
  cash: {
    id: 'Homeowner.equity.emergenciesQuestion.cash',
    defaultMessage: 'What are my cashout options?'
  },
  rate: {
    id: 'Homeowner.equity.emergenciesQuestion.rate',
    defaultMessage: 'What would my refi rate be?'
  },
  topic: {
    id: 'Homeowner.equity.emergenciesTopic.cash',
    defaultMessage: 'create an emergency fund'
  }
})

export default {
  GemContainer: connect(state => ({
    qaTag: 'emergencyReserveGem',
    amount: selectEmergencyReservePool(state)
  })),
  Detail: EmergencyReserve,
  topic: messages.topic,
  questions: [messages.cash, messages.rate],
  placeholder: true
}
